import React,{useState, useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import DashboardHeader from '../dashboardHeader'
import DashBoardContainer from '../../../components/containers/dashboardContainer'
import {
    submitFirmApplication,
    fetchProvince, 
    fetchDistricts,
    fetchSectors,
    fetchCells,
    fetchVillages,
    fetchFirmApplicationStatus as fetchFirmApplication,
    updateFirmApplication
} from '../../../actions'

import TextField from '../../../components/textField'
import VerticalSelectField from '../../../components/selectField/verticalSelectField'
import {SUBMIT_FIRM_APPLICATION_ID} from '../../../store/loaders'
import Residence from '../../../components/residence'
import TextArea from '../../../components/textarea'
import CountrySelector from '../../../components/countrySelector'
import { v4 as uuidv4 } from 'uuid'
import validator from 'validator'
import { normalizeInput } from '../../../utility/utils'





const CompanyContactDetails = (props)=>{

    const history = useHistory()
    const dispatch = useDispatch()

    const apiResponse = useSelector(state=>{
        const {
            provinces, 
            districts, 
            sectors, 
            villages, 
            cells,
            firmApplication,
            loader,
            firmApplicationSubmitted,
            hasUpdatedFirm
        } = state
        const {province} = provinces
        const {district} = districts
        const {sector} = sectors
        const {village} = villages
        const {cell} = cells
        const {application} = firmApplication
        const {isLoading} = loader[SUBMIT_FIRM_APPLICATION_ID] || {isLoading: false}
        const {response} = firmApplicationSubmitted
        const {updateId} = hasUpdatedFirm

        return{
            province,
            district,
            sector,
            village,
            cell,
            application,
            isLoading,
            response,
            updateId
        }
    })


    const [applicationDetails, setApplicationDetails] = useState({
        contactEmail: '',
        contactTelephoneNumber: '',
        secondaryContactEmail: '',
        secondaryContactTelephoneNumber: '',
        provinceId:{
            name: '',
            id: ''
        },
        sectorId:{
            name: '',
            id: ''
        },
        districtId: {
            name: '',
            id: '' 
        },
        cellId:{
            name: '',
            id: '' 
        },
        villageId:{
            name: '',
            id: '' 
        },
        streetOrHouseNumber: ''
    })

  
    var applicationId  = apiResponse.application?.id  ||  apiResponse.application?.applicationId
    var actionLoader = apiResponse.isLoading
    const appId = props.location.state && props.location.state.application?.id



    const [requestId, setRequestId] = useState('')
    const [emailError, setEmailError] = useState(false)
    const [emailHelperText, setEmailHelperText] = useState('')

    const [secondaryEmailError, setSecondaryEmailError] = useState(false)
    const [secondaryEmailHelperText, setSecondaryEmailHelperText] = useState('')
    const [hasFected, setHasFetched] = useState(false)


        
    useEffect(()=>{
        dispatch(fetchProvince())
        dispatch(fetchFirmApplication(appId))
    },[])


     useEffect(()=>{
        if(apiResponse.response?.status === 'success'){
            dispatch(fetchFirmApplication(appId))
        }
    },[apiResponse.response])


    useEffect(()=>{
        if(apiResponse.updateId === requestId && apiResponse.response?.status === 'success'){
            history.push({
                pathname: '/dashboard',
                state: applicationDetails
            })
        }
    },[apiResponse.updateId])

    useEffect(()=>{
        if(apiResponse.application?.id){
            setApplicationDetails({
                ...apiResponse.application
            })
            if(!hasFected){
                if(apiResponse.application?.provinceId){
                
                    dispatch(fetchDistricts(apiResponse.application?.provinceId?.id))
                }
                if(apiResponse.application?.districtId){
                    dispatch(fetchSectors(apiResponse.application?.districtId?.id))
                }
                if(apiResponse.application?.sectorId){
                    dispatch(fetchCells(apiResponse.application?.sectorId?.id))
                }
                if(apiResponse.application?.cellId){
                    dispatch(fetchVillages(apiResponse.application?.cellId?.id))
                }
                setHasFetched(true)
            }
        }
        if(apiResponse.application && apiResponse.application.residenceType === null){
            setApplicationDetails({
                ...apiResponse.application,
                residenceType: 'Local'
            })
        }
        
    },[apiResponse.application])


    var provinceArr 
    if(apiResponse.province && apiResponse.province.length > 0){
        provinceArr = apiResponse.province.map(value=>{
            return {value : value.id, label: value.name}
        })
    }

    var districtsArr
    if(apiResponse.district && apiResponse.district.length > 0){
        districtsArr = apiResponse.district.map(value=>{
            return {value : value.id, label: value.name}
        })
    }
    
    var sectorArr
    if(apiResponse.sector && apiResponse.sector.length > 0){
        sectorArr = apiResponse.sector.map(value=>{
            return {value : value.id, label: value.name}
        })
    }

    var cellArr
    if(apiResponse.cell && apiResponse.cell.length > 0){
        cellArr = apiResponse.cell.map(value=>{
            return {value : value.id, label: value.name}
        })
    }

    var villageArr
    if(apiResponse.village && apiResponse.village.length > 0){
        villageArr = apiResponse.village.map(value=>{
            return {value : value.id, label: value.name}
        })
    }


    const handleSaveForLater = ()=>{
        if(applicationDetails.contactEmail !== null && !validator.isEmail (applicationDetails.contactEmail)){
            setEmailError(true)
            setEmailHelperText("Invalid Email")
            return
        }
        if(applicationDetails.secondaryContactEmail !== null && !validator.isEmail (applicationDetails.secondaryContactEmail)){
            setSecondaryEmailError(true)
            setSecondaryEmailHelperText("Invalid Email")
            return
        }
        const reqId = uuidv4()
        setRequestId(reqId)

        if(applicationId){
            dispatch(updateFirmApplication({
                data:{
                    ...applicationDetails
                },
                id:applicationId,
                reqId: reqId
            }))
        }else{
            dispatch(submitFirmApplication({
                data:{
                    ...applicationDetails
                },
                id: applicationId,
                reqId: reqId
            }))
        }
    }

    const handleSubmit = ()=>{
      
        if(applicationDetails.contactEmail !== null && !validator.isEmail (applicationDetails.contactEmail)){
            setEmailError(true)
            setEmailHelperText("Invalid Email")
            return
        }
        if(applicationDetails.secondaryContactEmail !== null && !validator.isEmail (applicationDetails.secondaryContactEmail)){
            setSecondaryEmailError(true)
            setSecondaryEmailHelperText("Invalid Email")
            return
        }
        history.push({
            pathname: '/applicant/company/shareholders',
            state: {
                application: applicationDetails
            }
        })
        handleSaveForLater()
    }

    const handleCancel = ()=>{
        history.push({
            pathname: '/applicant/company/details',
            state:{
                application:applicationDetails
            }
        })
     }

    return (
        <div>
            <DashboardHeader
            activeStep={3}
            application={applicationDetails}/>
            <DashBoardContainer
                handleSubmit={handleSubmit}
                handleCancel={handleCancel}
                middleTitle="Save for Later"
                title="Next"
                handleSaveForLater={handleSaveForLater}
                disabled={actionLoader}
                loader={actionLoader}
                >
                <div className="first-step-container" >
                    <div style={{
                        width: '50%',
                    }}>
                        <div style={{
                             display: 'flex',
                             alignItems: 'center',
                             flexDirection: 'column',
                        }}>
                            <span className="dashboard-green-text-header">Main contacts</span>
                            <TextField 
                                title="Phone"
                                handleChange={(text)=>setApplicationDetails({
                                    ...applicationDetails,
                                    contactTelephoneNumber:normalizeInput(text.target.value,applicationDetails.contactTelephoneNumber)
                                })}
                                value={applicationDetails.contactTelephoneNumber}
                                type="tel"
                                required={true}
                                />
                            <TextField 
                                title="Email"
                                handleChange={(text)=>{setApplicationDetails({
                                    ...applicationDetails,
                                    contactEmail: text.target.value
                                })
                                setEmailHelperText('')
                                setEmailError(false)
                            }
                            }
                                value={applicationDetails.contactEmail}
                                type="email"
                                error={emailError}
                                helperText={emailHelperText}
                                required={true}
                                />
                        </div>
                        <div style={{
                             display: 'flex',
                             alignItems: 'center',
                             flexDirection: 'column'
                        }}>
                            <span className="dashboard-green-text-header">Secondary contacts</span>
                            <TextField 
                                title="Phone"
                                handleChange={(text)=>setApplicationDetails({
                                    ...applicationDetails,
                                    secondaryContactTelephoneNumber: normalizeInput(text.target.value,applicationDetails.secondaryContactTelephoneNumber)
                                })}
                                value={applicationDetails.secondaryContactTelephoneNumber}
                                type="tel"
                                required={true}
                                />
                            <TextField 
                                title="Email"
                                handleChange={(text)=>{setApplicationDetails({
                                    ...applicationDetails,
                                    secondaryContactEmail: text.target.value

                                })
                                setSecondaryEmailHelperText('')
                                setSecondaryEmailError(false)} 
                            }
                                value={applicationDetails.secondaryContactEmail}
                                type="email"
                                error={secondaryEmailError}
                                helperText={secondaryEmailHelperText}
                                required={true}
                                />
                        </div>
                    </div>
                        <div className="vertical-seperator"></div>
                    <div style={{
                        width: '50%',
                        marginBottom: 20
                        }}>
                            <div style={{
                             display: 'flex',
                             alignItems: 'center',
                             flexDirection: 'column'
                        }}>
                            <span className="dashboard-green-text-header">Registered Office Address</span>
                              <Residence
                                handleTitleChange={(text)=>setApplicationDetails({
                                    ...applicationDetails,
                                    residenceType: text.target.value
                                })}
                                titleValue={applicationDetails?.residenceType}
                                required={true}
                            />
                           {applicationDetails?.residenceType === '' || applicationDetails?.residenceType === 'Local' ? 
                            <>
                            <VerticalSelectField
                                required={true}
                                title="Province"
                                options={provinceArr}
                                handleChange={(text)=>{setApplicationDetails({
                                    ...applicationDetails,
                                    provinceId: {
                                        name: text.label,
                                        id: text.value
                                    },
                                    districtId: {
                                        name:'',
                                        id:''
                                    },
                                    sectorId: {
                                        name: '',
                                        id: ''
                                    },
                                    cellId: {
                                        name: '',
                                        id: ''
                                    },
                                    villageId: {
                                        name: '',
                                        id: ''
                                    }
                                });
                                dispatch(fetchDistricts(text.value));
                            }}
                                selectedOption={{value: applicationDetails.provinceId?.id, label:applicationDetails.provinceId?.name }}
                                // required={true}
                                />
                     
                            <VerticalSelectField 
                                required={true}
                                title="District"
                                options={districtsArr}
                                handleChange={(text)=>{setApplicationDetails({
                                    ...applicationDetails,
                                    districtId: {
                                        name:text.label,
                                        id:text.value
                                    },
                                    sectorId: {
                                        name: '',
                                        id: ''
                                    },
                                    cellId: {
                                        name: '',
                                        id: ''
                                    },
                                    villageId: {
                                        name: '',
                                        id: ''
                                    }
                                });
                                dispatch(fetchSectors(text.value));
                            }}
                                selectedOption={{label:applicationDetails.districtId?.name, value:applicationDetails.districtId?.id}}
                                // required={true}
                                />
                            <VerticalSelectField 
                                required={true}
                                title="Sector"
                                handleChange={(text)=>{setApplicationDetails({
                                    ...applicationDetails,
                                    sectorId: {
                                        name: text.label,
                                        id: text.value
                                    },
                                    cellId: {
                                        name: '',
                                        id: ''
                                    },
                                    villageId: {
                                        name: '',
                                        id: ''
                                    }
                                });
                                dispatch(fetchCells(text.value))
                            }}
                                options={sectorArr}
                                selectedOption={{value: applicationDetails.sectorId?.id, label:applicationDetails.sectorId?.name}}
                                // required={true}
                                />
                              <VerticalSelectField 
                                required={true}
                                title="Cell"
                                handleChange={(text)=>{setApplicationDetails({
                                    ...applicationDetails,
                                    cellId: {
                                        name: text.label,
                                        id: text.value
                                    },
                                    villageId: {
                                        name: '',
                                        id: ''
                                    }
                                });
                                dispatch(fetchVillages(text.value))
                            }}
                                options={cellArr}
                                selectedOption={{value: applicationDetails.cellId?.id, label:applicationDetails.cellId?.name}}
                                // required={true}
                                />
                            <VerticalSelectField 
                                required={true}
                                title="Village"
                                handleChange={(text)=>setApplicationDetails({
                                    ...applicationDetails,
                                    villageId: {
                                        name: text.label,
                                        id: text.value
                                    }
                                })}
                                options={villageArr}
                                selectedOption={{value: applicationDetails.villageId?.id, label:applicationDetails.villageId?.name}}
                                // required={true}
                                />
                                <TextField 
                                    title="Street/House number"
                                    type="text"
                                    handleChange={(text)=>setApplicationDetails({
                                        ...applicationDetails,
                                        streetOrHouseNumber: text.target.value
                                    })}
                                    value={applicationDetails.streetOrHouseNumber}/>
                                </> : 
                                        <>
                                    <CountrySelector
                                        required={true}
                                        title="Registered Country"
                                        handleNationality={(value)=>setApplicationDetails({
                                            ...applicationDetails,
                                            countryOfResidence:{
                                                name: value.label,
                                                id: value.value
                                            }
                                        })}
                                        nationality={{value: applicationDetails?.countryOfResidence?.id, label:applicationDetails?.countryOfResidence?.name }}/>
                                    <TextArea 
                                        required={true}
                                        title="Registered Address"
                                        handleChange={(text)=>setApplicationDetails({
                                            ...applicationDetails,
                                            residenceAddress: text.target.value
                                        })}
                                        value={applicationDetails.residenceAddress}/>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </DashBoardContainer>
        </div>
    )
}

export default CompanyContactDetails